export default __webpack_public_path__ + "static/media/KOD0127-min.68c3f659.webp";